import { Slide, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';
import { Fund } from '../../api/useFunds';
import { FundInput, FundInputProps } from './FundInput';
import { FundInputMobile } from './FundInputMobile';

type FundInputWrapperProps = FundInputProps & {
  onEdit: (fund: Fund) => void;
};

export const FundInputWrapper = ({ ...props }: FundInputWrapperProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const isLessMd = useMediaQuery(theme.breakpoints.down('md'));

  const [wasAnimated, setWasAnimated] = useState(false);
  const intersection = useIntersection(ref, {
    root: null,
    rootMargin: '0px',
    threshold: 1,
  });

  const shouldShowElement = wasAnimated || intersection?.isIntersecting;

  useEffect(() => {
    if (intersection?.isIntersecting) {
      setWasAnimated(true);
    }
  }, [intersection]);

  const FundInputComponent = isLessMd ? FundInputMobile : FundInput;

  return props.isAddedExternally ? (
    <div ref={ref}>
      {shouldShowElement && (
        <Slide in={shouldShowElement} direction="right" timeout={500}>
          <div>
            <FundInputComponent {...props} />
          </div>
        </Slide>
      )}
    </div>
  ) : (
    <FundInputComponent {...props} />
  );
};
